import React, { KeyboardEventHandler } from "react";
import { InputContainer, StyledTextField } from "../styles";
import { useAppTranslation } from "../../locales/translate";

interface Props {
  name: string;
  editName: (name: string | ((name: string) => string)) => void;
  isInvalid: boolean;
  label: string;
  onEnter: () => void;
}

export const EditNameInput = ({
  name,
  editName,
  isInvalid,
  label,
  onEnter,
}: Props) => {
  const { t } = useAppTranslation();

  const onEnterPress: KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (event.key === "Enter") onEnter();
  };

  return (
    <InputContainer>
      <StyledTextField
        label={label}
        helpText={
          isInvalid
            ? t("NAME_INPUT_EMPTY_HELP_TEXT")
            : t("NAME_INPUT_MAX_LENGTH_HELP_TEXT")
        }
        invalid={isInvalid}
        maxLength={50}
        defaultValue={name}
        onChange={(e) => editName(e.target.value)}
        onKeyPress={onEnterPress}
        autoFocus
      />
    </InputContainer>
  );
};
